<div class="confirmation-modal-container">
  <div id="hideModalBtn-1" class="d-flex d-md-none justify-content-center pt-2" (click)="bsModalRef.hide()">
    <img src="https://static-assets.vinlivt.de/icons/misc/mobile-gray-line.png" alt="line" />
  </div>

  <div class="modal-header d-flex align-items-center">
    <h4 class="section-title theme-color">{{ confirmationTitle }}</h4>
  </div>

  <div class="modal-body">
    <form [formGroup]="confirmationForm">
      <div class="row mb-3">
        <div class="col-12 theme-color" [innerHTML]="confirmationMessage"></div>
      </div>

      @if (confirmationInput) {
        <div class="row mb-3">
          <label class="text-danger">Gebe löschen ein</label>
          <div class="col-12">
            <input
              type="text"
              class="form-control form-control-lg"
              id="confirmationText"
              autocomplete="off"
              formControlName="confirmationText"
              (paste)="$event.preventDefault()"
            />
          </div>
        </div>
      }

      <!-- actions grouped on the right, cancel left of the primary; stacked full width on mobile (primary on top) -->
      <div class="row">
        <div class="col-12 modal-actions d-flex flex-column-reverse flex-md-row justify-content-md-end gap-2">
          <button id="hideModalBtn-2" type="button" class="btn btn-sm btn-noborder btn-outline" (click)="cancel()">
            Abbrechen
          </button>

          @if (danger && !success) {
            <button
              id="confirmBtn-1"
              class="btn btn-sm btn-primary"
              [disabled]="(confirmationInput && confirmationForm.invalid) || disableButton"
              (click)="confirm()"
            >
              @if (disableButton) {
                <span class="me-2">
                  <div class="spinner-border text-secondary" role="status" style="width: 14px; height: 14px"></div>
                </span>
              } @else {
                <i class="bi bi-x-lg me-2"></i>
              }

              @if (actionLabelBtn) {
                <span>{{ actionLabelBtn }}</span>
              } @else {
                <span>Löschen</span>
              }
            </button>
          } @else if (!danger && success) {
            <!-- success btn -->
            <button id="confirmBtn-2" class="btn btn-sm btn-primary" (click)="confirm()" [disabled]="disableButton">
              @if (disableButton) {
                <span class="me-2">
                  <div class="spinner-border text-secondary" role="status" style="width: 14px; height: 14px"></div>
                </span>
              } @else {
                <i class="bi bi-check-lg me-2"></i>
              }

              @if (actionLabelBtn) {
                <span>{{ actionLabelBtn }}</span>
              } @else {
                <span>Löschen</span>
              }
            </button>
          } @else {
            <!-- default btn -->
            <button id="confirmBtn-3" class="btn btn-sm btn-primary" (click)="confirm()" [disabled]="disableButton">
              @if (disableButton) {
                <span class="me-2">
                  <div class="spinner-border text-secondary" role="status" style="width: 14px; height: 14px"></div>
                </span>
              } @else {
                <i class="bi bi-check-lg me-2"></i>
              }

              @if (actionLabelBtn) {
                <span>{{ actionLabelBtn }}</span>
              } @else {
                <span>Löschen</span>
              }
            </button>
          }
        </div>
      </div>
    </form>
  </div>
</div>
